import { useEffect } from "react";
import { useSnackbar } from "notistack";

import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { Cancelled } from "../../types/ErrorTypes";

export function resolveAjaxErrorToasts(error: unknown, genericMessage: string): string[] | null {
  if (error == null || error === Cancelled) return null;
  if (ErrorResponse.isErrorResponse(error)) return error.messages.map(m => m.description);
  return [genericMessage];
}

export function useAjaxErrorToast(error: unknown, genericMessage: string) {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const messages = resolveAjaxErrorToasts(error, genericMessage);
    messages?.forEach((description, index) => {
      enqueueSnackbar(description, { variant: 'error', autoHideDuration: 5000 + index * 1500 });
    });
  }, [error, genericMessage, enqueueSnackbar]);
}
